<template>
    <div :class="{'actions-container': $vuetify.breakpoint.mdAndUp}">
        <v-row class="justify-end mx-0">
            <v-col md="2" lg="auto" class="px-1 px-lg-3 hidden-sm-and-down">
                <v-btn
                    icon
                    fab
                    small
                    text
                    class="white--text"
                    link
                    to="/calculator"
                >
                    <v-icon>calculate</v-icon>
                </v-btn>
            </v-col>
            <v-col md="2" lg="auto" class="px-1 px-lg-3 hidden-sm-and-down">
                <v-badge color="teal" overlap :value="comparedCount">
                    <span slot="badge">{{ comparedCount }}</span>
                    <v-btn
                        icon
                        fab
                        small
                        text
                        class="white--text"
                        link
                        to="/products/compare"
                    >
                        <v-img
                            contain
                            :src="comparedIconPaths.comparedPageHeader"
                            :width="comparedIconSizes.width"
                            :height="comparedIconSizes.height"
                        ></v-img>
                    </v-btn>
                </v-badge>
            </v-col>
            <v-col md="2" lg="auto" class="px-1 px-lg-3 hidden-sm-and-down">
                <v-badge color="teal" overlap :value="favoritesCount">
                    <span slot="badge">{{ favoritesCount }}</span>
                    <v-btn
                        icon
                        fab
                        small
                        text
                        class="white--text"
                        link
                        to="/profile/favorites"
                    >
                        <v-icon>favorite</v-icon>
                    </v-btn>
                </v-badge>
            </v-col>
            <v-col md="2" lg="auto" class="px-1 px-lg-3">
                <v-badge color="teal" overlap :value="addToBasketCount">
                    <span slot="badge">{{ addToBasketCount }}</span>
                    <v-btn
                        icon
                        fab
                        small
                        text
                        color="white"
                        to="/basket"
                    >
                        <v-icon>shopping_cart</v-icon>
                    </v-btn>
                </v-badge>
            </v-col>
            <v-col md="2" lg="auto" align-self="center" class="px-1 px-lg-3">
                <v-menu v-model="menuValue" class="mt-1">
                    <template #activator="{ on }">
                    <span v-on="on" style="cursor: pointer">
                        <img
                            v-if="profileData.src"
                            :src="profileData.src"
                            alt="profile-photo"
                        >
                        <v-icon v-if="!profileData.src">mdi-account-circle</v-icon>
                    </span>
                    </template>
                    <v-list dense>
                        <v-list-item v-for="link in menuItems" :key="link.to" :to="{name: link.to}">
                            <v-list-item-content class="subtitle-1 grey--text">
                                {{ link.title }}
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item link>
                            <v-list-item-content class="subtitle-1 text--main-yellow justify-center" @click="openSnack">
                                {{ $t('exit') }}
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-menu>
                <v-snackbar
                    color="main--black"
                    dark
                    v-model="snackOpen"
                    top
                >
                    {{ $t('exit?') }}
                    <div>
                        <v-btn text class="text--main-yellow" @click="$emit('logout')">{{ $t('yes') }}</v-btn>
                        <v-btn text icon @click="closeSnack">
                            <v-icon color="grey">close</v-icon>
                        </v-btn>
                    </div>
                </v-snackbar>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    import AddToBasket from '../../mixins/AddToBasket';
    import AppSnack from '../../../general/mixins/AppSnack';
    import Favorites from '../../mixins/Favorites';
    import ProductsCompare from '../../mixins/ProductsCompare';
    import ProfileDataProvider from "../../mixins/ProfileDataProvider";

    import "./header-profile.scss";

    export default {
        name: "HeaderProfile",
        mixins:[Favorites, AddToBasket, AppSnack, ProfileDataProvider, ProductsCompare],
        data() {
            return {
                mainRef: 'headerProfile',
                disabled: false,
                absolute: true,
                openOnHover: false,
                menuValue: false,
                closeOnClick: true,
                closeOnContentClick: true,
                offsetX: false,
                offsetY: false,
                menuData: [
                    {
                        route: 'profilePersonal',
                        title: this.$t('personalCabinet'),
                        forBuyer: true
                    },
                    {
                        route: 'companyPage',
                        title: this.$t('companyInfo'),
                        forBuyer: true
                    },
                    {
                        route: 'commercialPolicy',
                        title: this.$t('commercialPolicy'),
                        forBuyer: false
                    },
                    {
                        route: 'profileContracts',
                        title: this.$t('myContracts'),
                        forBuyer: false
                    },
                    {
                        route: 'profileBasket',
                        title: this.$t('myBasket'),
                        forBuyer: true
                    },
                    {
                        route: 'profileSales',
                        title: this.$t('mySales'),
                        forBuyer: false
                    },
                    {
                        route: 'profileProducts',
                        title: this.$t('productsManage'),
                        forBuyer: false
                    },
                    {
                        route: 'productAdd',
                        title: this.$t('addingProduct'),
                        forBuyer: false
                    },
                    /*{
                        route: 'profileMessages',
                        title: this.$t('messages'),
                        forBuyer: true
                    },*/
                    {
                        route: 'profileFavorites',
                        title: this.$t('favorites'),
                        forBuyer: true
                    },
                ]
            }
        },
        computed: {
            menuItems(){
                const items = [];
                this.menuData.forEach(item => {
                    if(this.isSeller) {
                        items.push({title: item.title, to: item.route});
                    }
                    else {
                        if(item.forBuyer) {
                            items.push({title: item.title, to: item.route});
                        }
                    }
                });
                return items;
            }
        },

    }
</script>

<style scoped lang="scss">
    @media only screen and (max-width: 1034px) {
        .add-product-link {
            display: none!important;
        }
    }
    .actions-container {
        width: 100%;
    }
</style>
